import { Box } from "@mui/material";
import React from "react";
import Information from "../../assets/Information/Information";
import { translation } from "../../assets/translation";
import { language } from "../../assets/function";

function Terms() {
  let staticText = translation[language];
  return (
    <Box>
      <Information
        heading={staticText.termsText}
        description={staticText.termsDesc}
      />
    </Box>
  );
}

export default Terms;
